import React from 'react';

import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { MetadataDrivenSiteSettings } from '~src/commonInfra/components/MetadataDrivenSiteSetting';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';

export const SEMANTIC_SEARCH_SECTION_NAME = 'hybridSearchEnabled';
export const SEMANTIC_SEARCH_SECTION_FORMIK_PREFIX = 'settings';
export const SEMANTIC_SEARCH_SECTION_TEST_ID = 'semantic-search-setting-section';

export function SemanticSearchSection(): React.ReactElement | null {
  if (!FeatureFlags.ces_HybridSearchQueryEnabled || !FeatureFlags.metadataDrivenSiteSettingsEnabled) {
    return null;
  }

  return (
    <SettingsSection
      title={Messages.semanticSearchSiteSettings()}
      testId={SEMANTIC_SEARCH_SECTION_TEST_ID}
    >
      <MetadataDrivenSiteSettings
        sectionName={SEMANTIC_SEARCH_SECTION_NAME}
        formikPrefix={SEMANTIC_SEARCH_SECTION_FORMIK_PREFIX}
      />
    </SettingsSection>
  );
}

export const SemanticSearchSectionSpecs = componentRegistryEntry({
  name: 'SemanticSearchSection',
  component: SemanticSearchSection,
});
